// src/components/issues/PastilleEvenement.tsx — SCE Issues
// Qui a fait quoi, en un rond (26/10, variante A de
// https://claude.ai/artifact/J7Cyu78UgKWKs6eDpkY9rN) : la photo de l'auteur
// (ses initiales tant qu'elle n'est pas là, ou s'il n'en a pas) et, en
// médaillon dans le coin, l'icône de l'événement à sa couleur. La ligne garde
// la taille qu'elle avait avec l'icône seule. Le filet blanc entoure le
// médaillon, jamais la photo.
//
// Activité récente de l'accueil et fil d'activité de la fiche problème.

import type { CommentaireType } from '@/types/issue.types'
import { PastillePersonne } from '@/components/personnes/PastillePersonne'
import { visuelEvenement } from './visuelEvenement'

export function PastilleEvenement({
  type,
  contenu,
  auteur,
  upn,
}: {
  type: CommentaireType
  contenu: string
  /** « Prénom Nom » de l'auteur ; vide = l'icône seule, comme avant. */
  auteur: string
  upn?: string
}): JSX.Element {
  const visuel = visuelEvenement(type, auteur ? 10 : 16, contenu)
  if (!auteur) {
    return (
      <span
        aria-hidden="true"
        className="flex items-center justify-center"
        style={{ width: 32, height: 32, flexShrink: 0, borderRadius: 16, backgroundColor: visuel.bg, color: visuel.color }}
      >
        {visuel.icon}
      </span>
    )
  }
  return (
    <span aria-hidden="true" style={{ position: 'relative', display: 'block', width: 32, height: 32, flexShrink: 0 }}>
      <PastillePersonne nom={auteur} upn={upn} taille={32} taillePolice={12} />
      <span
        className="flex items-center justify-center"
        style={{
          position: 'absolute',
          right: -4,
          bottom: -4,
          width: 18,
          height: 18,
          borderRadius: 9,
          backgroundColor: visuel.bg,
          color: visuel.color,
          boxShadow: '0 0 0 2px var(--color-white)',
        }}
      >
        {visuel.icon}
      </span>
    </span>
  )
}
